module.exports = __webpack_public_path__ + "img/logo.5f9a06b0.png";